const asbestos =[


{label:"Exposure over (years)",
controlType:"number",
options:[]
},

{label:"Frequency of exposure:",
controlType:"radio button",
options:["Most days", "Regularly", "Intermittently"]
},

{label:"Without protective equipment:",
controlType:"radio button",
options:["Yes", "No"]
},

{label:"Asbestos type(s):",
controlType:"checkbox group",
options:["Serpentine (white)", "Amphibolite (blue/ brown)"]
},

{label:"Last exposed (years)",
controlType:"number",
options:[]
},
]

export default asbestos
